import './tailwind.css';
import './app_tailwind.css'
import React, { useContext, useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Careers from "./Components/routes/Public/Careers/Careers";  
import Acquisitions from './Components/EmployeeHome/Acquisitions/Acquisitions';
import PropertyDetails from "./Components/EmployeeHome/Acquisitions/Property/PropertyDetails/PropertyDetails";
import AcqOptions from "./Components/EmployeeHome/Acquisitions/Forms/AcqOptions";
import AcqPaperwork from "./Components/EmployeeHome/Acquisitions/Forms/AcqPaperwork";
import DispoPaperwork from "./Components/EmployeeHome/Acquisitions/Forms/DispoPaperwork";
import Profile from './Components/EmployeeHome/Profile/Profile';
import Login from "./Components/Login/Login";
import OutboundCallsFull from "./Components/EmployeeHome/Reports/OutboundCallsFull";
import Opportunities from "./Components/EmployeeHome/Reports/Opportunities";
import NotAuthorized from './Components/EmployeeHome/NotAuthorized';
import EventCalendar from "./Components/EmployeeHome/EventCalendar/EventCalendar";
import DealText from "./Components/EmployeeHome/Acquisitions/Property/DealText";
import HR from './Components/EmployeeHome/HR/HR';
import PostJob from './Components/EmployeeHome/HR/PostJob/PostJob';
import Applications from './Components/EmployeeHome/HR/Applications/Applications';
import ITDashboard from './Components/EmployeeHome/IT/ITDashboard';
import PayoutData from './Components/EmployeeHome/HR/PayoutData/PayoutData';
import Videos from './Components/EmployeeHome/Onboarding/Videos';
import RemovePayouts from './Components/EmployeeHome/HR/RemovePayouts/RemovePayouts';
import YearPayout from './Components/EmployeeHome/HR/YearPayout/YearPayout';
import Inventory from './Components/EmployeeHome/Inventory/Inventory';
import EmailBlast from './Components/EmployeeHome/Acquisitions/Property/EmailBlast/EmailBlast';

import { Account, AccountContext } from './Components/Login/Account';
import Status from './Components/Login/Status';
import Settings from './Components/Login/Settings';
import ChangePassword from './Components/Login/ChangePassword';

import { Amplify, Auth } from 'aws-amplify';
import awsConfig from './aws-exports';
import { Authenticator, useTheme, View, Image, Text, Heading, useAuthenticator, Button } from '@aws-amplify/ui-react';
import { Box, TextField, Typography } from '@mui/material';


import './App.css'
import RequireAuth from './RequireAuth';
import NewPassword from './Components/Login/NewPassword';
import Cancellation from './Components/EmployeeHome/Acquisitions/Forms/Cancellation';
import TC from './Components/EmployeeHome/Inventory/TC';
import ToDetails from './Reroutes/ToDetails';
import ToDealText from './Reroutes/ToDealText';
import Sales from './Components/EmployeeHome/Inventory/Sales';
import { SideMenu } from './Components/EmployeeHome/Inventory/SideMenu';
import { InternalMenu, useStateContext } from './context/InternalContext';
// import ClosedProps from './Components/EmployeeHome/Inventory/ClosedProps';
import { InternalContext } from './context/InternalContext';
import Side from './Components/EmployeeHome/Inventory/Side';
import Navbar from './Components/EmployeeHome/Inventory/Navbar';


Amplify.configure(awsConfig);



const App = () => {
    const { activeMenu, showOuterBar } = useStateContext();
    const [ employee, setEmployee ] = useState('');

    return (
        <Router>
            <Account employee={employee} setEmployee={setEmployee}>
                <div className='flex relative'>
                {activeMenu ? (
                    <div className='w-80 fixed sidebar'>
                        <Side />
                    </div>
                ) : (
                    <div className='w-0'>
                        <Side />
                    </div>
                )}
                <div className={`bg-[#154a87b8] min-h-screen w-full ${activeMenu ? 'md:ml-80' : 'flex-2'}`}>
                    <div className={`${employee === '' ? 'hidden' : 'fixed'} md:static shadow-lg navbar w-full`}>
                        <Navbar />
                    </div>
                
            <Routes>
                {/* Home */}
                <Route path='/' exact element={<Login />} />

                {/* Reset Password */}
                {/* <Route path='/forgotpassword/:token' exact element={<ResetPassword />} /> */}

                {/* Employee Login */}
                <Route path='/newpassword/:user' element={<NewPassword />} />
                
                {/* <Route path='/dashboard' element={<Dashboard /> } /> */}
                {/* <Route path='/acquisitions' exact element={<Inventory />} /> */}
                <Route path='/internal' exact element={<TC />} />
                {/* <Route path='/closedproperties' exact element={<ClosedProps />} /> */}
                <Route path='/sales' exact element={<Sales />} />
                <Route path='/acquisitions/:id' exact element={<PropertyDetails />} />
                <Route path='/emailblast/:id' exact element={<EmailBlast />} />
                <Route path='/profile/:id' exact element={<Profile />} />
                {/* <Route path='/acquisitions/search' exact element={<Acquisitions />} /> */}

                {/* Reroutes */}
                <Route path='/routedetails/:address' element={<ToDetails />} />
                <Route path='/routedealtext/:address' element={<ToDealText />} />
                {/* Employee Reset Password */}
                <Route path ='/resetpassword' exact element={<ChangePassword />} />

                {/* <Route path='/acqTable/:id' exact element={<AcqDetails />} /> */}
                {/* <Route path='/map' exact element={<Map />} /> */}
                {/* <Route path='/guestmap' exact element={<GuestMap />} /> */}

                {/* Buyer Dashboard */}
                {/* <Route path='/dashboard' exact element={<BuyerDashboard />} />
                <Route path='/dashboard/:id' exact element={<Offer />} />
                <Route path='/dashboard/search' exact element={<BuyerDashboard />} /> */}

                <Route path='/careers' exact element={<Careers />} />
                {/* <Route path='/warehouse' exact element={<Warehouse />} /> */}
                <Route path='/acqoptions' exact element={<AcqOptions />} />
                <Route path='/acqpaperwork' exact element={<AcqPaperwork />} />
                <Route path='/dispopaperwork' exact element={<DispoPaperwork />} />
                <Route path='/cancellationform' exact element={<Cancellation />} />


                {/* Inventory */}
                {/* <Route path='/inventory' exact element={<Inventory />} /> */}

                {/* Event Calendar */}
                <Route path='/eventcalendar' exact element={<EventCalendar />} />

                {/* Deal Text */}
                <Route path='/dealtext/:id' exact element={<DealText />} />

                {/* Onboarding */}
                <Route path='/onboarding/videos' exact element={<Videos />} />

                {/* HR */}
                <Route path='/hr' exact element={<HR />} />
                <Route path='/hr/postjob' exact element={<PostJob />} />
                <Route path='/hr/applications' exact element={<Applications />} />
                <Route path='/hr/payoutdata' exact element={<PayoutData />} />
                <Route path='/hr/removepayouts' exact element={<RemovePayouts />} />
                <Route path='/hr/yearpayout' exact element={<YearPayout />} />

                {/* IT Dashboard */}
                <Route path='/itdashboard' exact element={<ITDashboard />} />


                {/* Reports */}
                <Route path='/callreports' exact element={<OutboundCallsFull />} />
                <Route path='/opportunityreports' exact element={<Opportunities />} />
                <Route path='/opportunityreports/:status' exact element={<Opportunities />} />
                <Route path='/notauthorized' exact element={<NotAuthorized />} />
            
                </Routes>
                    </div>
                </div>
                </Account>
        </Router>
    )
}




export default App
    
